import { Box, Grid } from '@mui/material'
import React, { useEffect } from 'react'
import CustomTable from '../../../../Components/Table/CustomTable'
import { useDispatch } from 'react-redux';
import { setHeaderName, setSubHeaderName } from '../../../../ReduxStore/Slices/headerSlice';

const EmpoloyeeDetails = () => {
    const tableHeadData = ["S.No", "Employee ID", "Department", "Sub Department", "Designation", "DOJ", "KRA & KPI", "Name", "Actions"];
    const tableData = [
        { employeeId: "384", department: "SALES", subdepartment: "SANITARYWARE", designation: "AASM - WATERTEC AQCETO", doj: "01 -08 - 2023", krakpi: 'SALES EXECUTIVE - 3105', name: "D S MOHANAKUMAR NARAKULA" },
        { employeeId: "589", department: "SALES", subdepartment: "SANITARYWARE", designation: "AASM - WATERTEC AQCETO", doj: "01 -08 - 2023", krakpi: 'SALES EXECUTIVE - 3105', name: "D S MOHANAKUMAR NARAKULA" },
        { employeeId: "077", department: "SALES", subdepartment: "SANITARYWARE", designation: "AASM - WATERTEC AQCETO", doj: "01 -08 - 2023", krakpi: 'SALES EXECUTIVE - 3105', name: "D S MOHANAKUMAR NARAKULA" },
        { employeeId: "985", department: "SALES", subdepartment: "SANITARYWARE", designation: "AASM - WATERTEC AQCETO", doj: "01 -08 - 2023", krakpi: 'SALES EXECUTIVE - 3105', name: "D S MOHANAKUMAR NARAKULA" },
        { employeeId: "0734", department: "SALES", subdepartment: "SANITARYWARE", designation: "AASM - WATERTEC AQCETO", doj: "01 -08 - 2023", krakpi: 'SALES EXECUTIVE - 3105', name: "D S MOHANAKUMAR NARAKULA" },


        { employeeId: "384", department: "SALES", subdepartment: "SANITARYWARE", designation: "AASM - WATERTEC AQCETO", doj: "01 -08 - 2023", krakpi: 'SALES EXECUTIVE - 3105', name: "D S MOHANAKUMAR NARAKULA" },
        { employeeId: "589", department: "SALES", subdepartment: "SANITARYWARE", designation: "AASM - WATERTEC AQCETO", doj: "01 -08 - 2023", krakpi: 'SALES EXECUTIVE - 3105', name: "D S MOHANAKUMAR NARAKULA" },
        { employeeId: "077", department: "SALES", subdepartment: "SANITARYWARE", designation: "AASM - WATERTEC AQCETO", doj: "01 -08 - 2023", krakpi: 'SALES EXECUTIVE - 3105', name: "D S MOHANAKUMAR NARAKULA" },
        { employeeId: "985", department: "SALES", subdepartment: "SANITARYWARE", designation: "AASM - WATERTEC AQCETO", doj: "01 -08 - 2023", krakpi: 'SALES EXECUTIVE - 3105', name: "D S MOHANAKUMAR NARAKULA" },
        { employeeId: "0734", department: "SALES", subdepartment: "SANITARYWARE", designation: "AASM - WATERTEC AQCETO", doj: "01 -08 - 2023", krakpi: 'SALES EXECUTIVE - 3105', name: "D S MOHANAKUMAR NARAKULA" },


    ]
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(setHeaderName("Master"));
        dispatch(setSubHeaderName("Employee Details"));
    }, [dispatch]);

    return (
        <div>
            <Box
                sx={{
                    background: "white",
                    p: 3,
                    mt: 6,
                    // maxWidth: "950px"
                }}
            >
                <Grid container spacing={2}>
                    <Grid item size={{ xs: 12 }} sx={{ width: "100px", flex: 1 }}>
                        <CustomTable
                            tableHeadData={tableHeadData}
                            tableData={tableData}
                            title="Employee Details List"
                            tableEdit={true}
                            tableActions={true}
                            tableSearch={true}
                            tableActivate={true}

                        />

                    </Grid>
                </Grid>
            </Box></div>
    )
}

export default EmpoloyeeDetails